import { combineReducers } from '@reduxjs/toolkit';
import { appReducer } from './app-slice';

import { propertiesReducer } from './properties-slice';
import { assessmentsReducer } from './assessments-slice';

import { propertyCreateReducer } from './property-create-slice';

// Combine all persisted reducers for QPS property management system
const rootReducer = combineReducers({
  app: appReducer,
  properties: propertiesReducer, // Legacy compatibility
  assessments: assessmentsReducer,
  propertyCreate: propertyCreateReducer, // Persisted multi-step create form
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
